import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc ToDoItemDetailActivityWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ToDoItemDetailActivityWidgetService } from 'services/toDoItemDetailActivityWidget';
 *
 * // create service instance and send/cancel request
 * const toDoItemDetailActivityWidgetService = new ToDoItemDetailActivityWidgetService();
 * const result = await toDoItemDetailActivityWidgetService.fetchData( '<user-id>' ); // fetch data
 * toDoItemDetailActivityWidgetService.cancel(); // cancel an active request
 */
export class ToDoItemDetailActivityWidgetService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} )
            };
        } catch( errResponse ) {
            return errResponse;
        }
    }

    // post additional comment/notes
    async onPost( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR )
            };
        } catch( errResponse ) {
            return errResponse;
        }
    }
}
